
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogButtonAdaptableRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogButtonAdaptableRT(): TemplateResult<dialogButtonAdaptableRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBox(function () {
            return _createElement('div', { 'className': 'cm_searchBox' }, _createElement('div', { 'className': 'cm_search-box_form-container' }, [
                [this.searchInput(function () {
                        return _createElement('div', { 'className': 'cm_searchInput' }, window.Convermax.config?.searchBoxPlaceholderText || _translate(`search_box_placeholder`));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })],
                _createElement('span', {
                    'className': 'cm_search-box_clear-container',
                    'key': '812'
                }, this.inputNotEmpty ? _createElement('span', {
                    'className': 'cm_search-box_clear',
                    'onClick': this.clearInput,
                    'key': '437'
                }, '\n    ', _translate(`search_box_clear`), '\n  ') : null),
                _createElement('button', {
                    'type': 'button',
                    'title': 'Search',
                    'aria-label': 'search button',
                    'className': 'cm_search-box_submit cm_button cm_button__primary',
                    'data-cm-role': 'add-query',
                    'key': '814'
                }, [_createElement('svg', {
                        'viewBox': '0 0 18 18',
                        'fill': 'none',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'key': '7330'
                    }, _createElement('g', { 'clipPath': 'url(#clip0_4412_12880)' }, _createElement('path', {
                        'd': 'M8.25 15.75C12.3921 15.75 15.75 12.3921 15.75 8.25C15.75 4.10786 12.3921 0.75 8.25 0.75C4.10786 0.75 0.75 4.10786 0.75 8.25C0.75 12.3921 4.10786 15.75 8.25 15.75Z',
                        'stroke': 'currentColor',
                        'strokeWidth': '1.25',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M17.2496 17.2501L13.9121 13.9126',
                        'stroke': 'currentColor',
                        'strokeWidth': '1.25',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_4412_12880' }, _createElement('rect', {
                        'width': '18',
                        'height': '18',
                        'fill': 'currentColor'
                    }))))])
            ]), [this.dropdown(function () {
                    function repeatSections1(sections, sectionsIndex) {
                        return [sections(function () {
                                function repeatItems1(sectionClass, items, itemsIndex) {
                                    return [items(function () {
                                            function mergeProps_product(inline, external) {
                                                var res = Object.assign({}, inline, external);
                                                if (inline.hasOwnProperty('style')) {
                                                    res.style = _.defaults(res.style, inline.style);
                                                }
                                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                                    res.className = external.className + ' ' + inline.className;
                                                }
                                                return res;
                                            }
                                            function mergeProps_text(inline, external) {
                                                var res = Object.assign({}, inline, external);
                                                if (inline.hasOwnProperty('style')) {
                                                    res.style = _.defaults(res.style, inline.style);
                                                }
                                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                                    res.className = external.className + ' ' + inline.className;
                                                }
                                                return res;
                                            }
                                            function mergeProps_facetValue(inline, external) {
                                                var res = Object.assign({}, inline, external);
                                                if (inline.hasOwnProperty('style')) {
                                                    res.style = _.defaults(res.style, inline.style);
                                                }
                                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                                    res.className = external.className + ' ' + inline.className;
                                                }
                                                return res;
                                            }
                                            return this.template === 'product' ? _createElement('div', { 'className': 'list-item cmTemplate_product' }, _createElement('div', { 'className': 'gap-3 d-flex fkex-wrap' }, _createElement('a', {
                                                'href': this.url,
                                                'className': 'd-block flex-shrink-0 predictive-search__image',
                                                'aria-label': 'Image of ' + this.removeHTML(this.title),
                                                'title': 'Image of ' + this.removeHTML(this.title)
                                            }, _createElement('img', {
                                                'src': this.imageOrDefault(this.image),
                                                'alt': 'Image of ' + this.removeHTML(this.title),
                                                'onError': this.onImageError,
                                                'width': '50',
                                                'height': '50'
                                            })), _createElement('div', { 'className': 'predictive-search__item-content' }, _createElement('a', mergeProps_product({
                                                'href': this.url,
                                                'className': 'fs-md fw-medium item--title lh-md text-black'
                                            }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'fw-medium lh-md ls-4 mt-1 sku-wrapper' }, 'SKU: ', this.removeHTML(this.sku)), _createElement('div', { 'className': 'fs-md fw-black lh-1 lh-md mt-2 price-wrapper' }, _createElement('span', { 'className': 'actual-price money' }, this.formatPrice(this.price)))))) : this.template === 'text' ? _createElement('div', mergeProps_text({ 'className': 'list-item col-lg-4 col-sm-6 cmTemplate_text' }, { dangerouslySetInnerHTML: { __html: typeof this.textHighlight === 'undefined' ? '' : this.textHighlight } })) : this.template === 'facetValue' ? _createElement('div', { 'className': 'cmTemplate_facetValue' }, _createElement('a', mergeProps_facetValue({
                                                'href': this.url,
                                                'className': 'fs-md fw-medium item--title lh-md text-black'
                                            }, { dangerouslySetInnerHTML: { __html: typeof this.value === 'undefined' ? '' : this.value } }))) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                        }, { count: undefined })];
                                }
                                function scopeSectionClass2() {
                                    var sectionClass = this.sectionTitle ? this.sectionTitle.toLowerCase() : 'suggestions';
                                    return _createElement('div', {
                                        'className': 'cm_section cm_section-' + sectionClass + '-container',
                                        'key': '7'
                                    }, _createElement('h6', { 'className': 'section-title fs-md fw-bold lh-1_2 ls-4 mb-3 text-uppercase' }, _createElement('b', {}, _translate(`search_box_section_${ this.sectionTitle }`) || this.sectionTitle, ' ')), _createElement.apply(this, [
                                        'div',
                                        { 'className': 'results-list cm_section-' + sectionClass + ' cmRepeater_items' },
                                        _map(this.items, repeatItems1.bind(this, sectionClass))
                                    ]));
                                }
                                return this.items?.length ? scopeSectionClass2.apply(this, []) : null;
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_autocomplete cm_dropdown' }, _createElement('div', { 'className': 'cm_dropdown-container border-gray-70 border-top' }, _createElement('div', {
                        'className': 'container mb-md-5 mb-4 pt-md-5 pt-4',
                        'role': 'listbox'
                    }, _createElement.apply(this, [
                        'div',
                        { 'className': 'row row-gap-5 justify-content-center cmRepeater_sections' },
                        _map(this.sections, repeatSections1.bind(this))
                    ]), this.noResults ? _createElement('div', {
                        'className': 'item cm_search-box_no-results',
                        'key': '5106'
                    }, '\n      ', _translate(`search_box_no_results`, {  query : this. query  }), '\n    ') : null), [this.browseAllButton(function () {
                            return _createElement('div', { 'className': 'mt-md-5 mt-4 py-md-8 py-3 text-center cm_browseAllButton' }, _createElement('a', { 'className': 'btn-dark btn-sm btn btn-primary' }, 'View All results'));
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchInput","cm:browseAllButton","cm:dropdown","cm:searchBox"]